import styled from '@emotion/styled';

import { HTML as _HTML } from '@hrworks/sui-core/Html';

import { getLinkColor } from '../../util/linkStyles';

const HTML = styled(_HTML)(({ theme }) => ({
  a: {
    color: getLinkColor(theme),
  },
}));

export const S = {
  HTML,
} as const;
